import React from 'react';

const GeofenceList = ({ geofences, selectedGeofence, onSelect, onEdit, onDelete }) => {
    return (
        <div className="splits-list">
            {geofences.map(gf => (
                <div
                    key={gf.id}
                    className={`geofence-item ${selectedGeofence?.id === gf.id ? 'selected' : ''}`}
                    onClick={() => onSelect(gf)}
                >
                    <div className="geofence-item-header">
                        <span className="geofence-name">{gf.name}</span>
                        <div className="geofence-actions">
                            <span className={`geofence-type-badge geofence-type-${gf.attributes?.pointType}`}>
                                {gf.attributes?.pointType || 'SPLIT'}
                            </span>
                            <button
                                className="btn-icon-small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit(gf);
                                }}
                                title="Edit"
                            >
                                <span className="material-icons-outlined" style={{ fontSize: '16px' }}>edit</span>
                            </button>
                            <button
                                className="btn-icon-small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(gf.id);
                                }}
                                title="Delete"
                                style={{ color: '#ef4444' }}
                            >
                                <span className="material-icons-outlined" style={{ fontSize: '16px' }}>delete</span>
                            </button>
                        </div>
                    </div>
                    <div className="geofence-details">
                        {gf.attributes?.stageId && <span>Stage: {gf.attributes.stageId}</span>}
                        {gf.attributes?.speedLimit && <span>Max: {gf.attributes.speedLimit} km/h</span>}
                    </div>
                </div>
            ))}

            {geofences.length === 0 && (
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-tertiary)' }}>
                    No geofences found. Add or Import one.
                </div>
            )}
        </div>
    );
};

export default GeofenceList;
